import {
  Box,
  Stack,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import ProgressBar from "./ProgressBar";
import { CustomInput } from "../Common/CustomInput";
import { ContactPhoneOutlined, PersonOutline } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useState } from "react";
import { CustomBtn, SecondaryBtn } from "../Common/CustomBtn";

const Welcome = ({
  setStep,
  progress,
  setProgress,
  formData,
  handleCheckboxChange,
  handleInputChange,
}) => {
  const { userData } = useSelector((state) => state.user);
  const [firstName, setFirstName] = useState(userData?.firstName || "");
  const [lastName, setLastName] = useState(userData?.lastName || "");
  const [contact, setContact] = useState(userData?.phone || "");
  const [portfolio, setPortfolio] = useState(userData?.portfolio || "");
  const [instagram, setInstagram] = useState(userData?.instagram || "");
  const [youtube, setYoutube] = useState(userData?.youtube || "");
  const [twitter, setTwitter] = useState(userData?.twitter || "");

  const [subscriptions, setSubscriptions] = useState({
    updates: false,
    promos: false,
  });

  // Handle checkbox change

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="start"
      height="100vh"
      textAlign="center"
      p={4}
    >
      <Box width={{ xs: "90vw", md: "50vw" }}>
        <Typography
          sx={{
            fontWeight: "400",
            fontSize: "32px",
            lineHeight: "40px",
            fontFamily: "Inter-Bold",
            mb: 2,
          }}
        >
          Welcome, let's get started...
        </Typography>
        <ProgressBar progress={progress} setProgress={setProgress} />
      </Box>

      <Box
        width={{ xs: "90vw", md: "50vw" }}
        display="flex"
        flexDirection="column"
        alignItems="start"
        gap={2}
        mt={4}
      >
        <Stack direction={{ xs: "column", md: "row" }} gap={2} width="100%">
          <CustomInput
            label={"First Name"}
            placeholder="First Name"
            Icon={PersonOutline}
            value={formData.user.firstName}
            setValue={(value) => handleInputChange("firstName", value)}
          />
          <CustomInput
            label={"Last Name"}
            placeholder="Last Name"
            Icon={PersonOutline}
            value={formData.user.lastName}
            setValue={(value) => handleInputChange("lastName", value)}
          />
        </Stack>

        {/* <Stack direction={{ xs: "column", md: "row" }} gap={2} width="100%">
          <CustomInput
            label={"Bank Name"}
            placeholder="ABC Bank"
            noIcon
            value={formData.user.bankName}
            setValue={(value) => handleInputChange("bankName", value)}
          />
          <CustomInput
            label={"IBAN"}
            placeholder="1234567891234"
            noIcon
            value={formData.user.iban}
            setValue={(value) => handleInputChange("iban", value)}
          />
        </Stack> */}
        <Stack direction={{ xs: "column", md: "row" }} gap={2} width="100%">
          <CustomInput
            label={"Instagram (recommended)"}
            placeholder="Instagram"
            noIcon
            value={formData.user.instagram}
            setValue={(value) => handleInputChange("instagram", value)}
          />
          <CustomInput
            label={"Youtube (recommended)"}
            placeholder="Youtube Link"
            noIcon
            value={formData.user.youtube}
            setValue={(value) => handleInputChange("youtube", value)}
          />
        </Stack>
        <Stack direction={{ xs: "column", md: "row" }} gap={2} width="100%">
          <CustomInput
            label={"X / Twitter (recommended)"}
            placeholder="X"
            noIcon
            value={formData.user.twitter}
            setValue={(value) => handleInputChange("twitter", value)}
          />
          <CustomInput
            label={"TikTok (recommended)"}
            placeholder="Tiktok"
            noIcon
            value={formData.user.tiktok}
            setValue={(value) => handleInputChange("tiktok", value)}
          />
        </Stack>

        <Box mt={3} width="100%">
          <Typography variant="h6" fontWeight="bold">
            Promotional Email Preference
          </Typography>
          <Stack direction={{ xs: "column", md: "row" }} spacing={2} mt={1}>
            <FormControlLabel
              control={
                <Checkbox
                  name="receivePromos" // ✅ FIXED: Name should match the state key
                  checked={formData.user.receivePromos}
                  onChange={handleCheckboxChange}
                  sx={{
                    color: "#FC0108",
                    "&.Mui-checked": { color: "#FC0108" },
                  }}
                />
              }
              label="I want to receive promotional emails."
            />
          </Stack>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "start",
            gap: 5,
            width: "100%",
          }}
        >
          {/* <SecondaryBtn
            text="Previous"
            noIcon
            width={"40%"}
            onClick={() => {
              console.log("Previous");
            }}
          >
            Previous
          </SecondaryBtn> */}
          <CustomBtn
            text="Next"
            noIcon
            width={"40%"}
            onClick={() => {
              setProgress(30);
              setStep(2);
            }}
          />
          <CustomBtn text="Save" noIcon width={"40%"} />
        </Box>
      </Box>
    </Box>
  );
};

export default Welcome;
